import { PortalRequest as request } from "@/utils/request";
// 动态列表
export const getActivityList = (params, data) => {
  return request({
    url: "/act-activity/list-activity",
    method: "post",
    params,
    data,
  });
};
// 详情
export const getActivityDetail = (id) => {
  return request({
    url: `/act-activity/${id}/info`,
    method: "get",
  });
};
// 评论列表
export const getActivityReviewList = (params, data) => {
  return request({
    url: `/act-activity/list-review`,
    method: "post",
    params,
    data,
  });
};
// 评论
export const activityComment = (id, data) => {
  return request({
    url: `/act-activity/${id}/review`,
    method: "post",
    data,
  });
};
// 用户中心我的活动
export const usermyactivity = (params, data) => {
  return request({
    url: `/act-activity/list-myactivity`,
    method: "post",
    params,
    data,
  });
};
// 点赞
export const thumbsupComment = (id, data) => {
  return request({
    url: `/act-activity/${id}/thumbsup`,
    method: "post",
    data,
  });
};
// 报名
export const activityEnroll = (id, data) => {
  return request({
    url: `/act-activity/${id}/enroll`,
    method: "post",
    data,
  });
};
export const getActivityEnrollInfo = (id) => {
  return request({
    url: `/act-activity/${id}/enroll-info`,
    method: "get",
  });
};
